import { render, staticRenderFns } from "./ContainerScanTable.vue?vue&type=template&id=6024c1a8&scoped=true&"
import script from "./ContainerScanTable.vue?vue&type=script&lang=ts&"
export * from "./ContainerScanTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContainerScanTable.vue?vue&type=style&index=0&id=6024c1a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024c1a8",
  null
  
)

export default component.exports